import TeacherPersonalInformation from './TeacherPersonalInformation.page';

export default TeacherPersonalInformation;